import React from 'react';
import { CheckCircleIcon } from '@heroicons/react/24/solid';
import { Link } from 'react-router-dom';

const FinalStep: React.FC = () => {
    return (
        <div className="text-center p-6">
            <CheckCircleIcon className="mx-auto h-16 w-16 text-green-500" />
            <h2 className="mt-4 text-2xl font-bold text-gray-800">Cadastro Atualizado com Sucesso!</h2>
            <p className="mt-2 text-gray-600">
                Obrigado por manter suas informações em dia. Já recebemos seus dados e está tudo certo.
            </p>
            <div className="mt-8">
                <Link
                    to="/dashboard"
                    className="bg-indigo-600 text-white px-8 py-3 rounded-md hover:bg-indigo-700 focus:outline-none"
                >
                    Voltar para o Início
                </Link>
            </div>
        </div>
    );
};

export default FinalStep;
